<template>
    <div>
        <v-row class="ma-16 text-center">
          <v-col cols="1"></v-col>  
          <v-col cols="10">
            <v-card class="mx-auto pa-12 pb-8" rounded="lg" max-width="500" variant="outlined" color="primary">
                <v-form ref="valid">
                    <v-row>
                        <v-text-field
                        v-model="username"
                        label="Nazwa użytkownika"
                        variant="outlined"
                        :rules="fieldRules"
                        ></v-text-field>
                    </v-row>
                    <v-row>
                        <v-text-field
                        v-model="password"
                        label="Hasło"
                        variant="outlined"
                        :append-inner-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showpass ? 'text' : 'password'"
                        @click:append-inner="showpass = !showpass"
                        :rules="fieldRules"
                        ></v-text-field>
                    </v-row>
                    <v-row justify="center" class="mb-2">
                        <v-btn color="primary" @click="formValid()">Zaloguj się</v-btn>
                    </v-row>
                </v-form>
            </v-card>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
        <v-snackbar
        v-model="snackbar"
        color="success"
        timeout="2000"
        >
        Zalogowano!
        <template v-slot:actions>
            <v-btn
            icon="mdi-close"
            color="white"
            @click="snackbar = false"
            >            
            </v-btn>
        </template>
        </v-snackbar>
    </div>
</template>

<script>
  import axios from 'axios'
  import { mapActions } from 'vuex';

  export default {
    data () {
      return {
        username: '',
        password: '',
        showpass: false,
        snackbar: false,
        fieldRules: [
            value => {
            if (value) return true
            return 'Pole nie może być puste.'
            },
        ],
      }
    },
    methods: {
      ...mapActions([
        'setUser',
        'setToken'
      ]),
      async formValid() {
        const { valid } = await this.$refs.valid.validate()
        if(valid) {
            axios
            .get(`${process.env.VUE_APP_API}/login`, {params: {'login': this.username, 'pass': this.password}})
            .then((resp) => {
                //console.log(resp);
                this.setUser(resp.data.username);
                this.setToken(resp.data.token);

                this.snackbar = true
                setTimeout( () => this.$router.push('/AdminPanel'), 2000);
            })
        }
      },
    }      
}
</script>